export const CREATE_COMPLAINT = "CREATE_COMPLAINT";
export const UPDATE_COMPLAINT = "UPDATE_COMPLAINT";
export const DELETE_COMPLAINT = "DELETE_COMPLAINT";
